module.exports = __webpack_public_path__ + "components/flag/static/square/ng-09aefe6fd4062ed9f821444fde8eb479.svg";